import React, { useEffect, useRef, useState } from "react"
import { Routes, Route, NavLink } from 'react-router-dom'
import Login from "./Login"
import EnPosts from "./en/posts"
import ArPosts from "./ar/posts"
import EnNewPost from "./en/newPost"
import ArNewPost from "./ar/newPost"
import EnEditPost from "./en/editPost"
import ArEditPost from "./ar/editPost"
import { useLocation } from 'react-router-dom';
import { IconButton } from "@mui/material"
import LogoutIcon from '@mui/icons-material/Logout';
import { auth } from "../firebase/firebase"
import { signOut } from "firebase/auth";

export default function Home({ setLoggedIn }) {
    const enRef = useRef()
    const arRef = useRef()
    const location = useLocation();

    const handleSignout = async () => {
        try {
            await signOut(auth);
            setLoggedIn(false)
        } catch (err) {
            alert(err)
        }
    }

    useEffect(() => {
        if (location.pathname.toString().includes('ar')) {
            enRef.current.classList.remove('active')
            arRef.current.classList.add('active')
        } else {
            enRef.current.classList.add('active')
            arRef.current.classList.remove('active')
        }
    }, [location])
    return (
        <>
            <IconButton onClick={handleSignout} sx={{
                position: 'fixed',
                top: '10px',
                right: '20px',
                backgroundColor: '#D0A847',
                '&: hover': {
                    backgroundColor: '#D0A847',
                    opacity: .7
                }
            }}>
                <LogoutIcon sx={{ width: '30px', height: '30px', color: "#fff" }} />
            </IconButton>
            <div style={{
                width: 'fit-content',
                margin: '5px auto',
                backgroundColor: 'white',
                borderRadius: '50px',
                marginTop: '10px',
                marginBottom: '10px',
                overflow: 'hidden',
                boxShadow: '0px 0px 10px 1px #D0A847 inset',
                padding: '10px 20px'
            }}>
                <ul style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                }}>
                    <li><NavLink to='/admin' ref={enRef} className={`nav-admin-link`} style={{ flex: 1, width: '100%', padding: '10px 30px', fontSize: '15pt', fontWeight: 'bold', fontFamily: 'Arial', color: '#D0A847' }}>English</NavLink></li>
                    <li><NavLink to='/admin/ar' ref={arRef} className={`nav-admin-link`} style={{ flex: 1, width: '100%', padding: '10px 30px', fontSize: '15pt', fontWeight: 'bold', fontFamily: 'Arial', color: '#D0A847' }}>Arabic</NavLink></li>
                </ul>
            </div>
            <div style={{
                height: `calc(100vh - 100px)`,
                position: 'fixed',
                top: '70px',
                width: '98vw',
                left: '50%',
                transform: 'translate(-50%, 0)',
                border: '3px solid #D0A847',
                borderRadius: '10px',
                padding: '20px',
                paddingBottom: '40px',
                overflow: 'hidden',
                boxShadow: '0px 0px 5px 3px #D0A847 inset',
                backgroundColor: '#fff'
            }}>
                <Routes>
                    <Route path="/" exact element={<EnPosts />} />
                    <Route path="ar" element={<ArPosts />} />
                    <Route path="new-post" element={<EnNewPost />} />
                    <Route path="new-post-ar" element={<ArNewPost />} />
                    <Route path="edit-post/:id" element={<EnEditPost />} />
                    <Route path="edit-post-ar/:id" element={<ArEditPost />} />
                </Routes>
            </div>
        </>
    )
}
